module.exports = "/_next/static/images/first-home-state_signup-mobile-349fb411ac812d7d54fa4b31088ca5e0.png";